module.exports = __webpack_public_path__ + "img/edit_black.b6ef67ff.svg";